<template>
    <form-row title="Balance Remaining to Purchase"
        :no_border="true"
        class="mb-8"
    >
        <input-money
            name="balance_after_earnest_money"
            :value="value"
            :read_only="true"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        value: {},
        read_only: { default: false },
    },
}
</script>
